import { Col, Row } from '@sravni/react-design-system/lib/Grid';
import { Skeleton } from '@sravni/react-design-system/lib/Skeleton';
import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';

const MobileRow: React.FC = () => (
  <Row gutter={[40, 16]}>
    <Col span={6}>
      <Space align="center" size={12}>
        <Skeleton.Paragraph width={20} />
        <Skeleton.Avatar />
        <Skeleton.Paragraph />
      </Space>
    </Col>
    <Col span={2} offset={1}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={2} offset={1}>
      <Skeleton.Paragraph />
    </Col>
  </Row>
);

const DesktopRow: React.FC = () => (
  <Row gutter={[40, 16]}>
    <Col span={3}>
      <Space align="center" size={12}>
        <Skeleton.Paragraph width={20} />
        <Skeleton.Avatar />
        <Skeleton.Paragraph />
      </Space>
    </Col>
    <Col span={1} offset={2}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={1} offset={1}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={1} offset={1}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={1} offset={1}>
      <Skeleton.Paragraph />
    </Col>
  </Row>
);

const MobileHeader: React.FC = () => (
  <Row gutter={[40, 16]}>
    <Col span={6}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={3}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={3}>
      <Skeleton.Paragraph />
    </Col>
  </Row>
);

const DesktopHeader: React.FC = () => (
  <Row gutter={[40, 16]}>
    <Col span={4}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={2}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={2}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={2}>
      <Skeleton.Paragraph />
    </Col>
    <Col span={2}>
      <Skeleton.Paragraph />
    </Col>
  </Row>
);

export const TableSkeleton: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        backgroundColor: 'var(--color-L100)',
        padding: '24px',
        borderRadius: '16px',
      }}
    >
      <Skeleton>
        {isMobile ? (
          <>
            <MobileHeader />
            <MobileRow />
            <MobileRow />
            <MobileRow />
            <MobileRow />
            <MobileRow />
          </>
        ) : (
          <>
            <DesktopHeader />
            <DesktopRow />
            <DesktopRow />
            <DesktopRow />
            <DesktopRow />
            <DesktopRow />
          </>
        )}
      </Skeleton>
    </div>
  );
};
